import { render, staticRenderFns } from "./optimizeKeyword.vue?vue&type=template&id=6cef005e&scoped=true"
import script from "./optimizeKeyword.vue?vue&type=script&lang=js"
export * from "./optimizeKeyword.vue?vue&type=script&lang=js"
import style0 from "./optimizeKeyword.vue?vue&type=style&index=0&id=6cef005e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cef005e",
  null
  
)

export default component.exports